import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-900">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          准备好开始你的galgame之旅了吗？
        </h2>
        <p className="text-sm text-background-400 max-w-lg mx-auto mb-8 leading-relaxed">
          无论是经典名作还是最新热门，这里都能找到你想要的galgame资源。
          现在就探索我们的资源库，开启属于你的游戏之旅。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/story"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap text-sm"
          >
            浏览galgame资源
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-800 text-background-200 font-medium rounded-full hover:bg-background-700 transition-all duration-300 whitespace-nowrap text-sm"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}